import Game from "../../../src/Game";
import ComponentManager from "./game/managers/ComponentManager";
import { ASSETS } from "./game/types/Config";

const canvas = document.querySelector("#canvas") as HTMLCanvasElement;

if (canvas) {
  (window as any).context = new Game(canvas, "", () => new ComponentManager(), ASSETS);
} else {
  console.error("Canvas is not found");
}
